import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Portal from 'src/layout/Portal/Portal';
import useEventListener from 'src/hooks/useEventListener';
import { TModalFullScreen, TModalSize } from 'src/type/modal-type';
import Button, { IButtonProps } from 'src/components/bootstrap/Button';
import FormGroup from 'src/components/bootstrap/forms/FormGroup';
import Input from 'src/components/bootstrap/forms/Input';
import Select from 'src/components/bootstrap/forms/Select';
import Option from 'src/components/bootstrap/Option';
import { BsXCircleFill } from 'react-icons/bs';

export default function ModalConfirm({ isOpen, exit, title, des, handleConfirm, t }) {
	return (
		<div>
			<Portal>
				<AnimatePresence mode='wait'>
					{isOpen && (
						<>
							<motion.div
								initial={{ scale: 0 }}
								animate={{ rotate: 0, scale: 1 }}
								transition={{
									type: 'spring',
									stiffness: 260,
									damping: 20,
								}}
								key='modal'
								className='modal show'
								style={{ display: 'block' }}
								tabIndex={-1}
								aria-hidden='true'>
								<div
									className='modal-dialog
                                modal-dialog-scrollable
                                modal-dialog-centered'>
									<div className='modal-content'>
										<div className='div_modal_confirm'>
											<p className='p_title_confirm'>{title}</p>
											<p className='p_des_confirm'>{des}</p>
											<div className='div_group_btn_confirm'>
												<Button onClick={exit} className='btn_cancel'>
													<span>{t('txt_cancel')}</span>
												</Button>
												<Button
													onClick={handleConfirm}
													className='btn_confirm'>
													<span>{t('txt_confirm')}</span>
												</Button>
											</div>
										</div>
									</div>
								</div>
							</motion.div>
							<div className='modal-backdrop show'></div>
						</>
					)}
				</AnimatePresence>
			</Portal>
		</div>
	);
}
